export * from './components/base-form-page.component';
export * from './components/base-index-page.component';
export * from './components/base-page.component';
export * from './modules/base-index.module';
export * from './modules/base-form.module';
export * from './modules/base-component.module';
